import { useMutation, useQueryClient } from 'react-query';
import ky from 'ky';

import Auth from 'src/services/api/auth/Auth';
import { queryKeys } from 'src/services/api/constants';
import { createBearerHeader } from 'src/common/api-utils';
import type { UserSettings } from 'src/services/api/users/settings/types';
import { url } from 'src/services/api/users/settings/constants';
import { useNotifications } from 'src/notifications';

type Request = Omit<UserSettings, 'auto_archive_lead_after_days'>

export const useUpdateUserSettings = () => {
    const accessToken = Auth.accessToken;
    const queryClient = useQueryClient();
    const { addNotification } = useNotifications();

    return useMutation<void, unknown, Request>(
        async (payload) => {
            if (!accessToken) {
                throw new Error('Access token is missing');
            }

            const headers = createBearerHeader(accessToken);
            await ky.patch(url, {
                headers: headers,
                json: payload
            });
        },
        {
            onSuccess: () => {
                queryClient.invalidateQueries([queryKeys.loggedInUser]);
                queryClient.invalidateQueries([queryKeys.teamMembers]);

                addNotification('User settings updated successfully', 'success');
            }
        }
    );
};